import{useRef as t}from"react";var r=r=>{const e=t(null);return null===e.current&&r>0&&(e.current=r),{totalItemCount:e.current??0}};export{r as useTotalItemCount};
//# sourceMappingURL=useTotalItemCount.js.map